<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ assistant.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <AssistantTabLinks />
                    <CRow class="pl-3 pb-3" />

                    <CRow class="pl-3 pb-3" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Название</CCol>
                        <CCol sm="9" class="col-form-label">{{ assistant.title }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Код</CCol>
                        <CCol sm="9" class="col-form-label">{{ assistant.code }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Юр. лицо</CCol>
                        <CCol sm="9" class="col-form-label">{{ assistant.legal_entity }}</CCol>
                    </CRow>
                    <CRow
                        v-if="assistant.partner"
                        form
                        class="form-group">
                        <CCol sm="3" class="col-form-label">Партнер</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CLink v-if="adminOnly" :to="`/partners/${assistant.partner.id}`">{{ assistant.partner.title }}</CLink>
                            <template v-else>{{ assistant.partner.title }}</template>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Короткое название</CCol>
                        <CCol sm="9" class="col-form-label">{{ assistant.short_title }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Краткое описание</CCol>
                        <CCol sm="9" class="col-form-label" v-html="assistant.description"></CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="pictureUrl"
                                class="m2"
                                width="300" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка поиска</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="squarePictureUrl"
                                class="m2"
                                width="300" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Расширенное время работы (Пример: с 07:00, до 02:00 след. дня)</CCol>
                        <CCol sm="9" class="col-form-label">{{ assistant.extended_schedule ? 'Включено' : 'Отключено' }}</CCol>
                    </CRow>
                    <Schedule :schedule="assistant.schedule" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Минимальный заказ</CCol>
                        <CCol sm="9" class="col-form-label">{{ assistant.min_price ? assistant.min_price : "" }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Телефон</CCol>
                        <CCol sm="9" class="col-form-label">{{ assistant.phone }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Активен</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(assistant.enabled)">
                                &nbsp;{{ assistant.enabled ? "Да" : "Нет" }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="goBack">Назад</CButton>
                    <CButton
                        color="danger"
                        class="mr-3"
                        @click="stopModal = true">Стоп</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <StopServiceModal
            :id="$route.params.id"
            :open="stopModal"
            :type="BUSINESS_TYPE.ASSISTANT"
            @stop-modal-close="stopModal = false"
            @stop-modal-update="setSchedule"
        />
    </CRow>
</template>

<script>
    import Vue from 'vue';

    import AssistantTabLinks from '@/components/assistant/AssistantTabLinks';
    import Schedule from '@/components/Schedule';
    import StopServiceModal from '@/components/StopServiceModal';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'Assistant',
        components: {
            AssistantTabLinks,
            Schedule,
            StopServiceModal
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {});
        },

        data() {
            return {
                assistant: {
                    schedule: [],
                    code: '',
                    title: '',
                    short_title: '',
                    description: '',
                    picture: '',
                    min_price: 0,
                    phone: '',
                    extended_schedule: false,
                    enabled: true,
                    position: 0,
                },
                stopModal: false,
                BUSINESS_TYPE,
                adminOnly: false
            };
        },

        computed: {
            pictureUrl() {
                if (this.assistant.picture) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.assistant.picture
                    );
                } else {
                    return '';
                }
            },
            squarePictureUrl() {
                if (this.assistant.square_picture) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.assistant.square_picture
                    );
                } else {
                    return '';
                }
            },
        },

        mounted() {
            this.adminOnly = !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            const id = this.$route.params.id;
            Vue.axios
                .get('/assistants/' + id)
                .then(resp => {
                    this.assistant = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },
        methods: {
            goBack() {
                this.$router.push({ path: '/assistants' });
            },
            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
            setSchedule(schedule) {
                if (schedule) {
                    this.assistant.schedule = schedule;
                }
            }
        },
    };
</script>
